import React from "react";

function ScreenHeader(props) {
	return <label style={{ fontSize: "30px", fontWeight: 650, padding: "8px 20px" }}>{props.title}</label>;
}

export default ScreenHeader;
